/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PassFieldName {
  FIRSTNAME = 'firstname',
  LASTNAME = 'lastname',
  EMAIL = 'email',
  PHONE = 'phone',
  PRICE = 'price',
  EXPIRATION_DATE = 'expiration_date',
  START_DATE = 'start_date',
  COMMENT = 'comment',
  STATUS = 'status',
  PASS_ORDER_PAGE_ID = 'pass_order_page_id',
  NUM_PUNCHES = 'num_punches',
}
